import {DEFAULT_THEME, useCurrentState} from "../../globalState";
import React, {useCallback, useEffect, useState} from "react";
import {useAPI, useTitle, useToolbar} from "../../stateHelpers";
import {useTranslation} from "react-i18next";
import lodash from "lodash";
import {apiPost, apiPut, apiURL} from "../../api";
import confirmationDialog from "../../confirmationDialog";
import $ from "jquery";
import FailedLoading from "../FailedLoading";
import CircularLoader from "../CircularLoader";
import snackbar from "../../snackbar";
import {IconButton} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import DrawerInfo from "../DrawerInfo";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import SignaturePadDialog from "../SignaturePadDialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import Add from "@material-ui/icons/Add";
import Remove from "@material-ui/icons/Remove";
import {withRouter} from "react-router-dom";
import {getColorByIndex, styles, useFractalWidth} from "./utils";
import withStyles from "@material-ui/core/styles/withStyles";
import WriteComment from "./WriteComment";
import ArrowGuide from "./ArrowGuide";
import PageImage from "./PageImage";
import ConfirmAndSend from "./ConfirmAndSend";
import DeclineBox from "./DeclineBox";
import SignRequestNotFound from "./SignRequestNotFound";
import TextField from "@material-ui/core/TextField";
import DownloadDocument from "./DownloadDocument";


function RequestPage(props) {
    let params = props.match.params;
    let classes = props.classes;
    let [ctheme, setTheme] = useCurrentState("theme");
    let [drawerInfo, setDrawerInfo] = useCurrentState("drawer_info");
    let [provideElement, setProvideElement] = useState({});
    let [providePage, setProvidePage] = useState({});
    let [mw, setMw] = useFractalWidth();
    let [_, setTitle] = useTitle();
    let [images, setImages] = useState([]);
    let [isShowingDecline, setDecline] = useState(false);
    let [sigpad, setSigpad] = useState({});
    let [globalComment, setGlobalComment] = useState("");
    let [downloadMenu, setDownloadMenu] = useState(null);
    let [mainMenu, setMainMenu] = useState(null);
    let [scale, setScale] = useState(window.innerWidth >= 1024 ? -30 : 0);
    const {t, i18n} = useTranslation();

    useEffect(() => {
        return () => {
            setTheme(DEFAULT_THEME);
        };
    }, []);

    let {data = {}, error, isLoading, doRetry} = useAPI((params.signer_id ? 'sign_request_for_signer' : 'sign_request') + "/" + (params.signer_id ? params.signer_id : params.id) + '?action=view');

    let [toolbar, setToolbar] = useToolbar();
    if (toolbar) {
        setToolbar(false);
    }

    let getActionText = () => {
        let finished = true;
        if (!data.document) {
            return "Sign";
        }
        let anyDeclined = false;
        for (let page of data.document.pages) {
            if (!page.placeholders) {
                continue;
            }
            for (let placeholder of page.placeholders) {
                let sindex = lodash.find(data.signers, {
                    id: placeholder.signer_id
                });

                if (sindex && sindex.declined) {
                    anyDeclined = true;
                }

                if (signerID && sindex && sindex.unique_id === signerID && !placeholder.signed && !(placeholder._image || placeholder.image)) {
                    finished = false;
                }
            }
        }

        if (anyDeclined) {
            return "Declined";
        }

        let sindex = lodash.find(data.signers, {
            unique_id: params.signer_id
        });

        if (!lodash.filter(data.signers, (sign) => sign.signed === null).length) {
            return "Download";
        }

        if (sindex) {
            if (sindex.signed) {
                return "Signed";
            }

            if (sindex.declined) {
                return "Declined";
            }
        }

        if (finished) {
            return "Finalize";
        }


        return "Sign";
    };

    let signerID = params.signer_id;

    let withMenu = useCallback((cb) => {
        return () => {
            setDownloadMenu(null);
            cb();
        };
    }, []);

    let withMainMenu = useCallback((cb) => {
        return () => {
            setMainMenu(null);
            cb();
        };
    }, [signerID]);


    useEffect(() => {
        if (i18n && data && data.sign_request) {
            i18n.changeLanguage(data.sign_request.language);
        }
    }, [data, i18n]);


    let documentDownload = useCallback(() => {
        let allSigned = true;
        for (let signer of data.signers) {
            if (!signer.signed) {
                allSigned = false;
            }
        }

        if (allSigned) {
            window.open(apiURL("sign_request_for_signer/" + signerID + '?action=download_document'), '_blank');
            return;
        }

        let dialog = {
            title: t("dialog_download_document"),
            okText: t("dialog_btn_download_document"),
            send: () => {
                let [send, message] = dialog.getData();
                if (!send) {
                    snackbar(t("dialog_download_confirm_action"));
                    return false;
                }
                if (send === "yes") {
                    apiPut("sign_request_for_signer/" + signerID, {
                        download_for_alternative_sign: true,
                        message: message
                    });
                }
                window.open(apiURL("sign_request_for_signer/" + signerID + '?action=download_document'), '_blank');
            },
            ok: () => {
                return dialog.send();
            },
            id: 'download',
        };
        dialog.content = <DownloadDocument dialog={dialog} signerID={signerID}/>;
        confirmationDialog(dialog);

    }, [data]);

    let logDownload = useCallback(() => {
        window.open(apiURL("sign_request_for_signer/" + signerID + '?action=download_log'), '_blank');
    }, []);


    let finalize = useCallback((event) => {
        let state = getActionText();
        if (state === "Finalize") {
            let dialog = {
                title: t("dialog_signed_title"),
                okText: t("dialog_signed_ok_button"),
                ok: false,
                id: 'finalize',
            };
            dialog.content =
                <ConfirmAndSend globalComment={globalComment}
                                setGlobalComment={setGlobalComment}
                                data={data}
                                documentDownload={documentDownload}
                                signerID={signerID}
                                reloadData={doRetry}
                                dialog={dialog}/>;
            confirmationDialog(dialog);
        } else if (state === "Download") {
            setDownloadMenu(event.currentTarget);
        } else {
            $('#arrowHead').click();
        }
    }, [data, globalComment, signerID]);

    let decline = useCallback(() => {
        let dialog = {
            title: t("dialog_decline_title"),
            ok: false
        };
        dialog.content =
            <DeclineBox globalComment={globalComment} setGlobalComment={setGlobalComment} signerID={signerID}
                        reloadData={doRetry} dialog={dialog}/>;
        confirmationDialog(dialog)
    }, [signerID, globalComment]);

    const {
        history,
        ...rest
    } = props;

    if (error) {
        if (error.response && error.response.status === 404) {
            return <SignRequestNotFound/>
        }
        return <FailedLoading retry={doRetry}/>
    }

    if (isLoading) {
        return <CircularLoader/>
    }

    setTitle("Signature request");
    let currentSetImage = null;
    let currentImage = null;
    let currentInfo = {width: 0, height: 0};
    let currentSetInfo = null;
    let openSignaturePad = (page, info, setImage, image) => {
        currentInfo = info;
        currentSetImage = setImage;
        currentSetInfo = info.set;
        currentImage = image;
        if (!sigpad.open) {
            return;
        }
        sigpad.open(info);
    };

    if (scale !== 0) {
        let negative = false;
        let dscale = scale;
        if (scale < 0) {
            negative = true;
            dscale = Math.abs(scale);
        }
        let scaled = dscale * mw / 100;
        if (negative) {
            mw -= scaled;
        } else {
            mw += scaled;
        }
    }

    let setSignature = (signapi) => {

        let setImageBase64 = function (data, extra) {
            currentSetImage(data);
            currentSetInfo(extra || {});
            $(window).trigger("imageChanged");
            setImages([1, ...images]);
        };

        if (signapi.tab === 1) {
            return apiPost("signature_text_font_color_to_base64", {
                text: signapi.text,
                width: Math.ceil(currentInfo.computed.width),
                height: Math.ceil(currentInfo.computed.height),
                font: signapi.font,
                color: signapi.fontColor
            }).then((res) => {
                setImageBase64("data:image/png;base64," + res.data.base_64, {
                    text: signapi.text,
                    text_font: signapi.font,
                    text_color: signapi.fontColor
                });
            }, () => {
                snackbar(t("Unable to save signature, please try again!"));
            });
        } else {
            setImageBase64(signapi.toDataURL());
        }
        setTimeout(function () {
            if (getActionText() === "Finalize") {
                finalize();
            } else {
                $('#arrowHead').click();
            }
        }, 1500);
    };


    let currentAddr = (inq) => {
        return window.location.protocol + '//' + window.location.host + '/request/view/' + inq;
    };

    let signed = false;
    let declined = false;
    if (!isLoading && data) {
        let sindex = lodash.find(data.signers, {
            unique_id: signerID
        });
        if (sindex) {
            declined = sindex.declined;
            signed = sindex.signed;
        }
        if (ctheme.primary.main !== data.identity.theme) {
            setTheme({
                primary: {
                    main: data.identity.theme
                },
                secondary: {
                    main: data.identity.theme_secondary
                }
            });
        }
    }
    if (!isLoading && !isShowingDecline && params.action === "decline" && !declined) {
        setDecline(true);
        decline();
    }

    let embed = window.location.search.indexOf("embed=1") !== -1;

    let extra = null;

    if (!signerID) {
        extra = <IconButton color="inherit" onClick={() => setDrawerInfo(!drawerInfo)}>
            <Icon>info</Icon>
        </IconButton>;
    }

    let disabledAction = getActionText() === "Signed" || getActionText() === "Declined";

    let actions = <React.Fragment>
        {signerID ?
            <Button className={"embed-action"} color="inherit"
                    disabled={disabledAction}
                    id={"finalizeButton"} onClick={finalize}>
                {t(getActionText())}
            </Button> : null}
        <IconButton className={"embed-action"} color="inherit" onClick={(event) => setMainMenu(event.currentTarget)}>
            <Icon>keyboard_arrow_down</Icon>
        </IconButton>
        {extra}
    </React.Fragment>;


    let embeded = <div className={"embeded-actions"}>{actions}</div>;

    return <div className={embed ? "embeded-viewer" : null}>
        <DrawerInfo>
            <div style={{padding: 8}}>
                <Typography variant={"h6"}>Information about this request</Typography>
                <Typography variant={"subtitle1"}>Signers</Typography>
                <div>
                    {data.signers.map((signer, index) => {
                        return <div key={index}>
                            <div>
                                <Chip style={{marginRight: 10, backgroundColor: getColorByIndex(index)}}
                                      label={signer.email}/>
                            </div>
                            {!signerID ?
                                <div><TextField fullWidth={true} readOnly={true} value={currentAddr(signer.unique_id)}/>
                                </div> : null}
                            <br/>
                        </div>
                    })}
                </div>
                {signerID && (!declined && !signed) ?
                    <div>
                        <Button color={"secondary"} onClick={decline} variant={"raised"}>Decline</Button>
                    </div> : null}
            </div>
        </DrawerInfo>
        <SignaturePadDialog
            api={(open, close) => {
                setSigpad({
                    open: open,
                    close: close
                });
            }}
            actionText={t("Sign")}
            cancelText={t("dialog_cancel")}
            getImage={() => currentImage}
            getInfo={() => currentInfo}
            action={setSignature}/>


        {!embed ?
            <div className={classes.root}>
                <AppBar className={"top-toolbar"} position="fixed">
                    <Toolbar>
                        <Typography variant="h6" color="inherit" className={classes.grow}>
                            {data.document.details.name}
                        </Typography>
                        {actions}
                    </Toolbar>
                </AppBar>
            </div> : embeded}

        <Menu
            anchorEl={mainMenu}
            open={Boolean(mainMenu)}
            onClose={() => setMainMenu(null)}
        >
            {signerID && (!declined && !signed) ?
                <MenuItem onClick={withMainMenu(decline)}>
                    <ListItemIcon>
                        <Icon>cancel</Icon>
                    </ListItemIcon>
                    <ListItemText primary={t("ui_decline")}/>
                </MenuItem> : null}

            <MenuItem onClick={withMainMenu(documentDownload)}>
                <ListItemIcon>
                    <Icon>cloud_download</Icon>
                </ListItemIcon>
                <ListItemText primary={t("ui_download")}/>
            </MenuItem>

        </Menu>


        <Menu
            anchorEl={downloadMenu}
            open={Boolean(downloadMenu)}
            onClose={() => setDownloadMenu(null)}
        >
            <MenuItem onClick={withMenu(documentDownload)}>
                <ListItemIcon>
                    <Icon>cloud_download</Icon>
                </ListItemIcon>
                <ListItemText primary={t("ui_document")}/>
            </MenuItem>

            <MenuItem onClick={withMenu(logDownload)}>
                <ListItemIcon>
                    <Icon>history</Icon>
                </ListItemIcon>
                <ListItemText primary={t("ui_log")}/>
            </MenuItem>

        </Menu>

        <div className={"scalator"}>
            <Grid container
                  direction="row"
                  justify="center"
                  alignItems="center">

                <Grid item>
                    <IconButton style={{cursor: 'text', background: 'transparent'}} disableRipple={true}>
                        <span style={{fontSize: 14}}>{(100 + scale)}%</span>
                    </IconButton>
                </Grid>
                <Grid item>
                    <IconButton onClick={() => setScale(scale + 10)}><Add/></IconButton>
                </Grid>
                <Grid item>
                    <IconButton onClick={() => setScale(scale - 10)}><Remove/></IconButton>
                </Grid>
            </Grid>
        </div>


        <br/>
        <br/>
        <div style={{paddingTop: window.innerWidth >= 1024 ? 64 : 30}}>

            <div style={{width: mw === 0 ? undefined : Math.floor(mw)}}
                 className={'main-page'}>{data.document.pages.map((page, index) => {
                return <PageImage provideElement={[provideElement, setProvideElement]}
                                  providePage={[providePage, setProvidePage]}
                                  scale={scale}
                                  mainWidth={mw}
                                  signerID={signerID}
                                  signerMode={signerID}
                                  openSignaturePad={openSignaturePad}
                                  data={data}
                                  page={page}
                                  key={index}/>;
            })}</div>
            <ArrowGuide signerID={signerID} scale={scale} providePage={providePage} provideElement={provideElement}/>
            <WriteComment request={data}
                          signerID={signerID}
                          globalComment={globalComment}
                          setGlobalComment={setGlobalComment}/>
        </div>
    </div>;
}

export default withRouter(withStyles(styles)(RequestPage));
